/**
 * 学会全景
 */

import Container from '@/containers';

const xhqjRouter = {
    path: '/xhqj',
    component: Container,
    redirect: '/xhqj/index',
    name: 'XueHuiQuanJing',
    meta: {
        title: '学会全景'
    },
    children: [
        {
            path: 'index',
            component: () => import('@/views/xhqj'),
            name: 'XueHuiQuanJing',
            meta: {
                title: '学会全景',
                index:3
            }
        },
        {
            path: 'hyqk',
            component: () => import('@/views/xhqj/hyqk'),
            name: 'HuiYuanQingKuang',
            meta: {
                title: '全国学会会员情况',
                subTitle:'学会全景',
                returnLink:'/xhqj'
            }
        },
        {
            path: 'jsqk',
            component: () => import('@/views/xhqj/jsqk'),
            name: 'JianSheQingKuang',
            meta: {
                title: '全国学会建设情况',
                subTitle:'学会全景',
                returnLink:'/xhqj'
            }
        },
        {
            path: 'lshcy',
            component: () => import('@/views/xhqj/lshcy'),
            name: 'LiShiHuiChengYuan',
            meta: {
                title: '全国学会理事会成员情况',
                subTitle:'学会全景',
                returnLink:'/xhqj'
            }
        },
        {
            path: 'sjkjst',
            component: () => import('@/views/xhqj/sjkjst'),
            name: 'ShiJieKeJieSheTuan',
            meta: {
                title: '世界主要科技社团成立数量',
                subTitle:'学会全景',
                returnLink:'/xhqj'
            }
        },
        {
            path: 'zhnl',
            component: () => import('@/views/xhqj/zhnl'),
            name: 'ZongHeYeWuNengLi',
            meta: {
                title: '全国学会综合业务能力评估',
                subTitle:'学会全景',
                returnLink:'/xhqj'
            }
        },
        {
            path: 'xhpm',
            component: () => import('@/views/xhqj/xhpm'),
            name: 'xhpm',
            meta: {
                title: '学会排名三级',
                subTitle:'上一页',
                returnLink:'/xhqj/zhnl'
            }
        }
    ]
};

export default xhqjRouter;